import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { updateTrialStatus } from '../services/authService';

export const useTrialExpiration = () => {
  const { user, logout } = useAuth();

  useEffect(() => {
    const checkTrialExpiration = async () => {
      if (!user || !user.isTrial || !user.trialEndDate) return;

      const today = new Date();
      const endDate = new Date(user.trialEndDate);
      
      // Se o trial expirou
      if (today > endDate) {
        try {
          // Desativar a conta
          await updateTrialStatus(user.uid, false);
          
          // Fazer logout
          await logout();
          
          // Redirecionar para login com mensagem
          window.location.href = '/login?expired=true';
        } catch (error) {
          console.error('Error handling trial expiration:', error);
        }
      }
    };

    // Verificar imediatamente
    checkTrialExpiration();

    // Verificar a cada hora
    const interval = setInterval(checkTrialExpiration, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, [user, logout]);
};

export default useTrialExpiration;
